cb.define(['common/common_VM.Extend.js'], function (common) {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };

    var proMap = {};
    var PM_pmc_wholesale_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            viewmodel.get('cMonthDays').setState('min', 1);
            viewmodel.get('cMonthDays').setState('max', 31);
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            var unit = cb.rest.AppContext.user.currencyName || "元";
            var user = cb.rest.AppContext.user;

            const cacheCodesMapFunction = function (refGridModel, index, rowIndexes, bSelect, bAll) {
                // let index = viewmodel.get('pricePreferentialItem').getFocusedRowIndex();
                let rows = bAll ? refGridModel.getRows() : refGridModel.getRowsByIndexes(rowIndexes);
                let pros = proMap[index] || [];
                rows.map(row => {
                    let i = pros.findIndex(pro => {
                        return pro.productskus_id == row.productskus_id;
                    });
                    if (bSelect) {
                        if (i == -1) pros.push(row);
                    } else {
                        if (i != -1) pros.splice(i, 1);
                    }
                });
                proMap[index] = pros;
            }

            const displayReferType = (viewmodel, value) => {
                var refCode = "";
                var refRetId = "";
                //1商品分类 2 商品模板 3 商品品牌 4 商品标签
                if (value == 1) {
                    refCode = "pc_presentationclassref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 2) {
                    refCode = "pc_producttplref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 3) {
                    refCode = "pc_brandref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 4) {
                    refCode = "pc_tagref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                }
                if (refCode) {
                    viewmodel.get("pricePreProductClass").setRefCode(refCode, refRetId);
                }
            }


            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "proId": "id", "sProductName": "cName", "sProductCode": "code", "fSalePrice": "fSalePrice",
                        "fMarketPrice": "fMarkPrice", "sProductPicUrl": "url", "cDescribe": "modelDescription"
                    };
                    let sku_refRetId = {
                        "proId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarketPrice": "fMarkPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    };
                    let pro_refRetId1 = {
                        "iProductId": "id", "sProductName": "cName", "sProductCode": "code", "fSalePrice": "fSalePrice",
                        "fMarkPrice": "fMarkPrice", "sProductPicUrl": "url", "cDescribe": "modelDescription"
                    };
                    let sku_refRetId1 = {
                        "iProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarkPrice": "fMarkPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    };
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                    viewmodel.get("pricePreMustBuyPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId1));
                    viewmodel.get("pricePreMustBuyPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId1));
                    viewmodel.get("pricePreExceptionPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId1));
                    viewmodel.get("pricePreExceptionPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId1));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "proId": "id", "sProductName": "cName", "sProductCode": "code", "fSalePrice": "fSalePrice",
                        "fMarketPrice": "fMarketPrice", "sProductPicUrl": "url", "cDescribe": "modelDescription"
                    };
                    let sku_refRetId = {
                        "proId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarketPrice": "fMarketPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    };
                    let pro_refRetId1 = {
                        "iProductId": "id", "sProductName": "cName", "sProductCode": "code", "fSalePrice": "fSalePrice",
                        "fMarkPrice": "fMarketPrice", "sProductPicUrl": "url", "cDescribe": "modelDescription"
                    };
                    let sku_refRetId1 = {
                        "iProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarkPrice": "fMarketPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    };
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                    viewmodel.get("pricePreMustBuyPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId1));
                    viewmodel.get("pricePreMustBuyPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId1));
                    viewmodel.get("pricePreExceptionPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId1));
                    viewmodel.get("pricePreExceptionPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId1));
                }
            }

            const displayiAreaId = (viewmodel) => {
                delPro();
                let iRange = viewmodel.get("iRange").getValue();
                //平台
                if (iRange == 0) {
                    viewmodel.get("iAreaId").setVisible(false);
                    viewmodel.get("iAreaId").setValue(null);
                    viewmodel.get('btnImport').setVisible(true);
                    viewmodel.get('btnExport').setVisible(true);
                    if (viewmodel.get('pActivityRange').getValue() == 0) {
                        viewmodel.get('btnBatchOp').setVisible(true);
                    }
                } else {
                    viewmodel.get("iAreaId").setVisible(true);
                    viewmodel.get('btnImport').setVisible(false);
                    viewmodel.get('btnExport').setVisible(false);
                    // viewmodel.get('btnBatchOp').setVisible(false);
                }
            }

            const delPro = () => {
                if (viewmodel.get('pricePreProduct').getData() && viewmodel.get('pricePreProduct').getData().length > 0) {
                    let pricenums = viewmodel.get('pricePreProduct').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('pricePreProduct').deleteRows(i);
                    }
                }
            }

            const delMustBuyPro = () => {
                if (viewmodel.get('pricePreMustBuyPro').getData() && viewmodel.get('pricePreMustBuyPro').getData().length > 0) {
                    let pricenums = viewmodel.get('pricePreMustBuyPro').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('pricePreMustBuyPro').deleteRows(i);
                    }
                }
            }

            const delExPro = () => {
                if (viewmodel.get('pricePreExceptionPro').getData() && viewmodel.get('pricePreExceptionPro').getData().length > 0) {
                    let pricenums = viewmodel.get('pricePreExceptionPro').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('pricePreExceptionPro').deleteRows(i);
                    }
                }
            }


            const hiddenField = (editRowModels) => {
                editRowModels.get('discountNum').setState('visible', false);
                editRowModels.get('fireNum').setState('visible', false);
                editRowModels.get('isCapping').setState('visible', false);
                editRowModels.get('giveNum').setState('visible', false);
                editRowModels.get('remitType').setState('visible', false);
                editRowModels.get('cGiftNames').setState('visible', false);
            }
            const displayField = (editRowModels, fieldList) => {
                fieldList.forEach(function (field) {
                    editRowModels.get(field).setVisible(true);
                });
            }

            const setInputnumberValue = (editRowModels, i, field) => {
                if (viewmodel.get('pricePreferentialItem').getCellValue(i, field)) {
                    editRowModels.get(field).setValue(0, true);
                }
            }

            const controlDecimal = (editRowModels) => {
                editRowModels.get('consumerPieces').setState('min', 0);
                editRowModels.get('consumerSpending').setState('min', 0);
                editRowModels.get('discountNum').setState('min', 0);
                editRowModels.get('discountNum').setState('max', 10);
                editRowModels.get('fireNum').setState('min', 0);
                editRowModels.get('giveNum').setState('min', 0);
            }

            const displayMustBuyPro = () => {
                if (viewmodel.get('bMusetBuyProduct').getValue() && viewmodel.get('bMusetBuyProduct').getValue() == 1) {
                    if (viewmodel.getParams().mode != 'browse') {
                        viewmodel.execute('updateViewMeta', {
                            code: 'mustbuyprotab',
                            visible: true
                        });
                    }
                    viewmodel.get('pricePreMustBuyPro').setVisible(false);
                } else {
                    delMustBuyPro();
                    viewmodel.execute('updateViewMeta', {
                        code: 'mustbuyprotab',
                        visible: false
                    });
                    viewmodel.get('pricePreMustBuyPro').setVisible(true);
                }
            }

            const displayExPro = () => {
                if (viewmodel.get('bExceptionalProduct').getValue() && viewmodel.get('bExceptionalProduct').getValue() == 1) {
                    if (viewmodel.getParams().mode != 'browse') {
                        viewmodel.execute('updateViewMeta', {
                            code: 'exprotab',
                            visible: true
                        });
                    }
                    viewmodel.get('pricePreExceptionPro').setVisible(false);
                } else {
                    delExPro();
                    viewmodel.execute('updateViewMeta', {
                        code: 'exprotab',
                        visible: false
                    });
                    viewmodel.get('pricePreExceptionPro').setVisible(true);
                }
            }

            const displayAccumulative = () => {
                let pAccumulative = viewmodel.get("pAccumulative").getValue();
                let editRowModels = viewmodel.get('pricePreferentialItem').getCache('editRowModels');
                if (editRowModels) {
                    if (pAccumulative == 0) {
                        for (let i = 0; i < editRowModels.length; i++) {
                            editRowModels[i].get('fireNum').setState('cShowCaption', '减价');
                        }
                        viewmodel.get('bMusetBuyProduct').setVisible(true);
                    } else {
                        viewmodel.get('bMusetBuyProduct').setVisible(false);
                        viewmodel.get('bMusetBuyProduct').setValue(0);
                        for (let i = 0; i < editRowModels.length; i++) {
                            editRowModels[i].get('fireNum').setState('cShowCaption', '每件减');
                        }
                    }
                    displayMustBuyPro();
                }
            }

            const disableAccumulative = (able) => {
              let auditStatusModel = viewmodel.get('pAccumulative');
              let stat = {};
              if(able) {
                stat[2] = able;
                if(auditStatusModel.getValue() ==2){
                  auditStatusModel.setValue(1);
                }
              }else{
                stat[2] = able;
              }
              common.enumEnable(auditStatusModel,stat)
            }

          const displayPType = (menuStyle) => {
                let pType = viewmodel.get('pType').getValue();
                let iTem = viewmodel.get('pricePreferentialItem');
                let editRowModels = viewmodel.get('pricePreferentialItem').getCache('editRowModels');
                if (pType == 2) {
                    // viewmodel.get("pricePreProduct").getEditRowModel().get("sProductCode").setState('bCanModify',false);
                    viewmodel.get('pricePreProduct').setColumnState('sProductCode', 'bCanModify', false);
                    viewmodel.get('pAccumulative').setValue(0);
                    viewmodel.get('pAccumulative').setDisabled(true);
                    viewmodel.get('bMusetBuyProduct').setVisible(true);
                } else {
                    viewmodel.get('pricePreProduct').setColumnState('sProductCode', 'bCanModify', true);
                    viewmodel.get('pAccumulative').setDisabled(false);
                }
                if (editRowModels) {
                    for (let i = 0; i < editRowModels.length; i++) {
                        let fieldList = new Array();
                        hiddenField(editRowModels[i]);
                        controlDecimal(editRowModels[i]);
                        editRowModels[i].get('consumerSpending').setState("after", unit);
                        editRowModels[i].get('fireNum').setState("after", unit);
                        if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                            editRowModels[i].get('consumerSpending').setState("iNumPoint", 2);
                            editRowModels[i].get('giveNum').setState("iNumPoint", 2);
                        } else {
                            editRowModels[i].get('consumerSpending').setState("iNumPoint", 2);
                            editRowModels[i].get('giveNum').setState("iNumPoint", 0);
                        }
                        if (pType == 0) {
                            fieldList.push('discountNum');
                            displayField(editRowModels[i], fieldList);
                            editRowModels[i].get('isCapping').setValue(0, true);
                            if (menuStyle) {
                                setInputnumberValue(editRowModels[i], i, 'fireNum');
                                setInputnumberValue(editRowModels[i], i, 'giveNum');
                            }
                            if (viewmodel.get('pricePreferentialItem').getCellValue(i, 'cGiftNames')) {
                                editRowModels[i].get('cGiftNames').setValue(null, true);
                                editRowModels[i].get('cGiftIds').setValue(null, true);
                            }
                        } else if (pType == 1) {
                            fieldList.push('fireNum', 'isCapping');
                            displayField(editRowModels[i], fieldList);
                            if (menuStyle) {
                                setInputnumberValue(editRowModels[i], i, 'discountNum');
                                setInputnumberValue(editRowModels[i], i, 'giveNum');
                            }
                            if (viewmodel.get('pricePreferentialItem').getCellValue(i, 'cGiftNames')) {
                                editRowModels[i].get('cGiftNames').setValue(null, true);
                                editRowModels[i].get('cGiftIds').setValue(null, true);
                            }
                        } else if (pType == 2) {
                            if (viewmodel.get('pricePreferentialItem').getCellValue(i, 'remitType') == 0) {
                                fieldList.push('giveNum', 'remitType', 'isCapping');
                            } else {
                                fieldList.push('cGiftNames', 'giveNum', 'remitType', 'isCapping');
                                // if(viewmodel.get('applicableChannel').getValue() == 1){
                                //     // editRowModels[i].get('cGiftNames').setState('multiple', true);
                                //     // editRowModels[i].get('cGiftNames').clearCache('vm');
                                //     if (editRowModels[i].get('cGiftNames').getCache('vm')){
                                //         editRowModels[i].get('cGiftNames').getCache('vm').get('table').setState('multiple', true);
                                //     }else{
                                //         editRowModels[i].get('cGiftNames').setState('multiple', true);
                                //     }
                                // }else{
                                //     // editRowModels[i].get('cGiftNames').setState('multiple', false);
                                //     // editRowModels[i].get('cGiftNames').clearCache('vm');
                                //     if (editRowModels[i].get('cGiftNames').getCache('vm')){
                                //         editRowModels[i].get('cGiftNames').getCache('vm').get('table').setState('multiple', false);
                                //     }else{
                                //         editRowModels[i].get('cGiftNames').setState('multiple', false);
                                //     }
                                // }

                            }
                        }
                        displayField(editRowModels[i], fieldList);
                        if (menuStyle) {
                            setInputnumberValue(editRowModels[i], i, 'discountNum');
                            setInputnumberValue(editRowModels[i], i, 'fireNum');
                        }
                        editRowModels[i].get('cGiftNames').on('afterBrowse', () => {
                            let sGiftSkuNames = editRowModels[i].get('cGiftNames');
                            let vm = sGiftSkuNames.getCache('vm');
                            let refGridModel = vm.get('table');
                            refGridModel.setState('rowKeyField', 'productskus_id');
                            var focusedRowIndex = i;
                            var currentPreferentialPro = iTem.getRow(focusedRowIndex);
                            var skuids = currentPreferentialPro.cGiftIds ? currentPreferentialPro.cGiftIds.split(',') : [];
                            var skunames = currentPreferentialPro.cGiftNames ? currentPreferentialPro.cGiftNames.split(',') : [];
                            var pros = [];
                            for (let i = 0; i < skuids.length; i++) {
                                let newobj = {};
                                newobj.productskus_id = skuids[i];
                                newobj.name = skunames[i];
                                pros.push(newobj);
                            }
                            proMap[focusedRowIndex] = pros;
                            refGridModel.un('afterSetDataSource');
                            refGridModel.un('beforeUnselect');
                            refGridModel.un('beforeSelect');
                            refGridModel.un('beforeSelectAll');
                            refGridModel.un('beforeUnselectAll');
                            refGridModel.on('afterSetDataSource', data => {
                                let selectIndexes = [];
                                // let fIndex = iTem.getFocusedRowIndex();
                                data.forEach((row, index) => {
                                    let i = proMap[focusedRowIndex].findIndex(item => {
                                        return row.productskus_id == item.productskus_id;
                                    });
                                    if (i != -1) selectIndexes.push(index);
                                });
                                refGridModel.select(selectIndexes);
                                let condition = {
                                    "isExtend": true,
                                    simpleVOs: []
                                };
                                common.addProductReferCondition(viewmodel, 1, condition, null, null, false);
                                let params = vm.getParams();
                                if (params.where && params.where.filter) {
                                    vm.getParams().where.filter = condition;
                                }
                            });
                            refGridModel.on('beforeUnselect', indexes => {
                                cacheCodesMapFunction(refGridModel, focusedRowIndex, indexes, false);
                            });
                            refGridModel.on('beforeSelect', indexes => {
                                cacheCodesMapFunction(refGridModel, focusedRowIndex, indexes, true);
                            });
                            refGridModel.on('beforeSelectAll', args => {
                                cacheCodesMapFunction(refGridModel, focusedRowIndex, null, true, true);
                            });
                            refGridModel.on('beforeUnselectAll', args => {
                                cacheCodesMapFunction(refGridModel, focusedRowIndex, null, false, true);
                            });
                        });
                    }
                }
            }

            viewmodel.get('pAccumulative').on('afterValueChange', function (data) {
                displayAccumulative();
            });

            viewmodel.get('bMusetBuyProduct').on('afterValueChange', function (data) {
                displayMustBuyPro();
            });
            viewmodel.get('bExceptionalProduct').on('afterValueChange', function (data) {
                displayExPro();
            });

            viewmodel.get('iAreaId').on('afterValueChange', function (data) {
                common.displayArea(viewmodel);
                delPro();
            });
            viewmodel.get("iRange").on('afterValueChange', () => {
                displayiAreaId(viewmodel);
            })

            viewmodel.get('pType').on('afterValueChange', function () {
                if (viewmodel.get('pType').getValue() == 2) {
                    delPro();
                }
                displayPType(true);
            })

            viewmodel.get('activityMode').on('afterValueChange', function () {
                common.displayActivityMode(viewmodel);
            });

            viewmodel.get("pricePreferentialItem").on('afterInsertRow', function (args) {
                displayPType(false);
                displayAccumulative();
            });

            viewmodel.get("pricePreferentialItem").on('afterDeleteRows', function (args) {
                displayPType(false);
                displayAccumulative();
            });

            viewmodel.get("pricePreferentialItem").on('afterCellValueChange', function (args) {
                let fieldList = new Array();
                let editRowModels = viewmodel.get('pricePreferentialItem').getCache('editRowModels')[args.rowIndex];
                let remitType = viewmodel.get('pricePreferentialItem').getCellValue(args.rowIndex, 'remitType');
                if (args.cellName == 'remitType') {
                    if (viewmodel.get('pType').getValue() == 2) {
                        hiddenField(editRowModels);
                        if (remitType == 0) {
                            fieldList.push('giveNum', 'remitType', 'isCapping');
                            editRowModels.get('cGiftIds').setValue(null, true);
                            editRowModels.get('cGiftNames').setValue(null, true);
                        } else {
                            fieldList.push('cGiftNames', 'giveNum', 'remitType', 'isCapping');
                            // if(viewmodel.get('applicableChannel').getValue() == 1){
                            //     if (editRowModels.get('cGiftNames').getCache('vm')){
                            //         editRowModels.get('cGiftNames').getCache('vm').get('table').setState('multiple', true);
                            //     }else{
                            //         editRowModels.get('cGiftNames').setState('multiple', true);
                            //     }
                            // }else{
                            //     if (editRowModels.get('cGiftNames').getCache('vm')){
                            //         editRowModels.get('cGiftNames').getCache('vm').get('table').setState('multiple', false);
                            //     }else{
                            //         editRowModels.get('cGiftNames').setState('multiple', false);
                            //     }
                            // }
                        }
                        displayField(editRowModels, fieldList);
                    }
                }
            })

            viewmodel.on('beforeDeleteRow', function (args) {
                let pricePreferentialItem = viewmodel.get('pricePreferentialItem').getRows();
                if (pricePreferentialItem && pricePreferentialItem.length == 1 && args.params.params.cItemName == 'btnDeleteRow3') {
                    cb.utils.alert("只有一个分组无法删除");
                    return false;
                }
            })

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_wholesale');
            })

            viewmodel.on("modeChange", function (data) {
                mode = data;
                if (data == "browse") {
                    common.displaySonBtn(viewmodel, 'pricePreferentialItem');
                } else {
                    let editRowModels = viewmodel.get('pricePreferentialItem').getCache('editRowModels');
                    for (let i = 0; i < editRowModels.length; i++) {
                        editRowModels[i].get('btnAddRow3').setVisible(true);
                        editRowModels[i].get('btnDeleteRow3').setVisible(true);
                    }
                    common.displayArea(viewmodel);
                    displayPType(false);
                    if (viewmodel.get('pActivityRange').getValue() == 0) {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: false
                        });
                        viewmodel.get('pricePreProductClass').setVisible(false);
                        viewmodel.get('actityItemType').setVisible(false);
                    } else {
                        viewmodel.get('actityItemType').setVisible(true);
                        if (viewmodel.get('actityItemType').getValue() == 0) {
                            viewmodel.execute('updateViewMeta', {
                                code: 'goodstab',
                                visible: true
                            });
                            viewmodel.get('pricePreProductClass').setVisible(false);
                        } else {
                            viewmodel.execute('updateViewMeta', {
                                code: 'goodstab',
                                visible: false
                            });
                            viewmodel.get('pricePreProductClass').setVisible(true);
                            displayReferType(viewmodel, viewmodel.get("actityItemType").getValue());
                        }
                    }
                    common.displayChannel(viewmodel, 'wholesale');
                }
            })

            viewmodel.on('afterMovenext', function (data) {
                common.displaySonBtn(viewmodel, 'pricePreferentialItem');
            })

            viewmodel.on('afterMoveprev', function (data) {
                common.displaySonBtn(viewmodel, 'pricePreferentialItem');
            })

            viewmodel.on('afterLoadData', function (data) {

                if (mode === 'add'&&viewmodel.get('pName').getValue()==undefined) {
                    viewmodel.get('pricePreferentialItem').appendRow({});
                }
                displayPType(false);
                displayAccumulative();
                displayPrice(viewmodel);
                common.displayArea(viewmodel);
                common.displayChannel(viewmodel, 'wholesale');
                common.hideNoStore(viewmodel);
                common.displayActivityMode(viewmodel);
                common.displayEditButton(viewmodel, "pValid");
                if (viewmodel.get('pActivityRange').getValue() == 0) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('pricePreProductClass').setVisible(false);
                    viewmodel.get('actityItemType').setVisible(false);
                } else {
                    viewmodel.get('actityItemType').setVisible(true);
                    if (viewmodel.get('actityItemType').getValue() == 0) {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: true
                        });
                        viewmodel.get('pricePreProductClass').setVisible(false);
                        viewmodel.get('bExceptionalProduct').setVisible(false);
                    } else {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: false
                        });
                        viewmodel.get('pricePreProductClass').setVisible(true);
                        displayReferType(viewmodel, viewmodel.get("actityItemType").getValue());
                    }
                }
                displayExPro();
                if (this.get('memberLevelAll').getValue() == 0) {
                    viewmodel.get('pricePreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('pricePreferentialMemberL').setVisible(false);
                }
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["1"]);
                    viewmodel.get('iSendPoint').setVisible(true);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('applicableChannel').setValue(["0"]);
                    viewmodel.get('iSendPoint').setVisible(false);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                    viewmodel.get('iSendPoint').setVisible(false);
                }
                if (this.get('applyOnlineChannel').getValue() == 0) {
                    viewmodel.get('terminalType').setVisible(false);
                } else {
                    viewmodel.get('terminalType').setVisible(true);
                }
                if (this.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('pricePreferentialStore').setVisible(false);
                    viewmodel.get('offLineStore').setValue(1);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (viewmodel.get('offLineStore').getValue() == 1) {
                        viewmodel.get('pricePreferentialStore').setVisible(false);
                    } else {
                        viewmodel.get('pricePreferentialStore').setVisible(true);
                    }
                }

                disableAccumulative(viewmodel.get('applyOnlineChannel').getValue() == 1 || viewmodel.get('applyOnlineChannel').getValue() == '1');
            });

            viewmodel.get('memberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    viewmodel.get('pricePreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('pricePreferentialMemberL').setVisible(false);
                }
            });


            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('pricePreferentialStore').setVisible(false);
                // viewmodel.get("pricePreferentialItem").getEditRowModel().get('consumerPieces').setState('iNumPoint', 0);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('iSendPoint').setVisible(false);
                var on = 0;
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                        viewmodel.get('iSendPoint').setVisible(false);
                        // viewmodel.get("pricePreferentialItem").getEditRowModel().get('consumerPieces').setState('iNumPoint', 0);
                        var on = 1;
                    }
                    if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('pricePreferentialStore').setVisible(false);
                        } else {
                            viewmodel.get('pricePreferentialStore').setVisible(true);
                        }
                        if (on == 0) {
                            viewmodel.get('iSendPoint').setVisible(true);
                            // viewmodel.get("pricePreferentialItem").getEditRowModel().get('consumerPieces').setState('iNumPoint', 2);
                        }
                    }
                }
                displayPrice(viewmodel);
                let editRowModels = viewmodel.get('pricePreferentialItem').getCache('editRowModels');
                if (editRowModels) {
                    for (let i = 0; i < editRowModels.length; i++) {
                        editRowModels[i].get('cGiftIds').setValue(null, true);
                        editRowModels[i].get('cGiftNames').setValue(null, true);
                        if (viewmodel.get('applicableChannel').getValue() == 1) {
                            editRowModels[i].get('consumerSpending').setState("iNumPoint", 2);
                            editRowModels[i].get('giveNum').setState("iNumPoint", 2);
                            // if (editRowModels[i].get('cGiftNames').getCache('vm')){
                            //     editRowModels[i].get('cGiftNames').getCache('vm').get('table').setState('multiple', true);
                            // }else{
                            //     editRowModels[i].get('cGiftNames').setState('multiple', true);
                            // }
                        } else {
                            // if (editRowModels[i].get('cGiftNames').getCache('vm')){
                            //     editRowModels[i].get('cGiftNames').getCache('vm').get('table').setState('multiple', false);
                            // }else{
                            //     editRowModels[i].get('cGiftNames').setState('multiple', false);
                            // }
                            editRowModels[i].get('consumerSpending').setState("iNumPoint", 2);
                            editRowModels[i].get('giveNum').setState("iNumPoint", 0);
                        }
                    }
                }
                // 仅选择线下门店时，活动规则可选按单行累计
                let onlyOffline = data.value.length == 1 && data.value[0].value == 1;
                disableAccumulative(!onlyOffline);
            });

            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value == 1) {
                    viewmodel.get('pricePreferentialStore').setVisible(false);
                } else {
                    viewmodel.get('pricePreferentialStore').setVisible(true);
                }
            });

            viewmodel.get('pActivityRange').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    if (viewmodel.get('pricePreProductClass').getData() && viewmodel.get('pricePreProductClass').getData().length > 0) {
                        viewmodel.get('pricePreProductClass').setValue([]);
                    }
                    delPro();
                    delExPro();
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('pricePreProductClass').setVisible(false);
                    viewmodel.get('actityItemType').setVisible(false);
                    viewmodel.get('bExceptionalProduct').setVisible(true);
                } else {
                    viewmodel.get('actityItemType').setVisible(true);
                    if (viewmodel.get('actityItemType').getValue() == 0) {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: true
                        });
                        viewmodel.get('pricePreProductClass').setVisible(false);
                        viewmodel.get('bExceptionalProduct').setVisible(false);
                        viewmodel.get('bExceptionalProduct').setValue(0);
                        displayExPro();
                    } else {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: false
                        });
                        viewmodel.get('pricePreProductClass').setVisible(true);
                        viewmodel.get('bExceptionalProduct').setVisible(true);
                        delExPro();
                        displayReferType(viewmodel, viewmodel.get("actityItemType").getValue());
                    }
                }
            })

            viewmodel.get("actityItemType").on('afterValueChange', function (args) {
                if (viewmodel.get('pricePreProductClass').getData() && viewmodel.get('pricePreProductClass').getData().length > 0) {
                    viewmodel.get('pricePreProductClass').setValue([]);
                }
                delPro();

                if (args.value.value == 0) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: true
                    });
                    viewmodel.get('pricePreProductClass').setVisible(false);
                    if (viewmodel.get('pActivityRange').getValue() == 1) {
                        viewmodel.get('bExceptionalProduct').setVisible(false);
                        viewmodel.get('bExceptionalProduct').setValue(0);
                        displayExPro();
                    }
                } else {
                    viewmodel.get('bExceptionalProduct').setVisible(true);
                    delExPro();
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('pricePreProductClass').setVisible(true);
                    displayReferType(viewmodel, args.value.value);
                }
            })

            viewmodel.get("pricePreProduct").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'proIdType', 1);
                } else {
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                    this.setCellValue(args.rowIndex, 'proIdType', 0);
                }
            })

            viewmodel.get("pricePreMustBuyPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 1);
                } else {
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                    this.setCellValue(args.rowIndex, 'iProductIdType', 0);
                }
            })

            viewmodel.get("pricePreExceptionPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 1);
                } else {
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                    this.setCellValue(args.rowIndex, 'iProductIdType', 0);
                }
            })

            viewmodel.get("pricePreferentialItem").on('beforeInsertRowsFromRefer', function (data) {
                let newData = proMap[data.index];
                var row = {};
                if (newData) {
                    let returnIdKey = "productskus_id";
                    let returnNameKey = "name";
                    let nameKey = "cGiftNames";
                    let idKey = "cGiftIds";
                    row[idKey] = "";
                    row[nameKey] = "";
                    for (let i = 0; i < newData.length; i++) {
                        if (newData[i][returnIdKey] && newData[i][returnIdKey] != "") {
                            row[idKey] += newData[i][returnIdKey];
                            if (i != newData.length - 1)
                                row[idKey] += ",";
                        }
                        if (newData[i][returnNameKey] && newData[i][returnNameKey] != "") {
                            row[nameKey] += newData[i][returnNameKey];
                            if (i != newData.length - 1)
                                row[nameKey] += ",";
                        }
                    }
                    data.rows.length = 0;
                    data.rows.push(row);
                }
            })

            viewmodel.get("pricePreferentialItem").on("beforeBrowse", function (data) {
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        let areaId = viewmodel.get("iAreaId").getValue();
                        let externalData = {"areaId": areaId};
                        data.context.setState('externalData', externalData);
                    }
                }
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };

                // if(viewmodel.get('pricePreProduct').getRows() == ''){
                //     cb.utils.alert('请选择参加活动的商品', 'warning');
                //     return false;
                // }else{}
                let item = viewmodel.get('pricePreferentialItem').getRows()[data.rowIndex];
                let cGiftIds = item.cGiftIds;
                let exitIds = [];
                let field = '';
                if (cGiftIds && cGiftIds != '') {
                    exitIds = String(cGiftIds).split(",");
                    field = 'id';
                } else {
                    if (viewmodel.get('pActivityRange').getValue() == 1) {
                        if (viewmodel.get('actityItemType').getValue == 0) {
                            field = 'id';
                            let pros = viewmodel.get('pricePreProduct').getRows();
                            for (let i = 0; i < pros.length; i++) {
                                if (pros[i].proId) {
                                    exitIds.push(pros[i].proId);
                                }
                            }
                        } else {
                            for (let i = 0; i < viewmodel.get('pricePreProductClass').getShowValue().length; i++) {
                                exitIds.push(viewmodel.get('pricePreProductClass').getShowValue()[i].iReferenceId);
                            }
                            if (viewmodel.get('actityItemType').getValue() == 1) {
                                field = 'productId.productClass';
                            } else if (viewmodel.get('actityItemType').getValue() == 2) {
                                field = 'productId.productTemplate';
                            } else if (viewmodel.get('actityItemType').getValue() == 3) {
                                field = 'productId.brand';
                            } else if (viewmodel.get('actityItemType').getValue() == 4) {
                                field = 'productId.productTags.tagId';
                            }
                        }
                    }
                }
                if (exitIds.length > 0) {
                    condition.simpleVOs.push({
                        field: field,
                        op: 'in',
                        value1: exitIds
                    });
                }
                common.addProductReferCondition(viewmodel, 1, condition, null, null, false);
                data.context.setFilter(condition);
                return true;
            });

            viewmodel.get("pricePreProduct").on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, "proIdType", "pricePreProduct", null, areaId);
                return true;
            });

            viewmodel.get("pricePreMustBuyPro").on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, "iProductIdType", "pricePreMustBuyPro", null, areaId);
                return true;
            });

            viewmodel.get('pricePreExceptionPro').on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, "iProductIdType", "pricePreExceptionPro", null, areaId);
                if (viewmodel.get('pricePreProductClass').getShowValue() && viewmodel.get('pricePreProductClass').getShowValue().length > 0) {
                    let ids = [];
                    for (let i = 0; i < viewmodel.get('pricePreProductClass').getShowValue().length; i++) {
                        ids.push(viewmodel.get('pricePreProductClass').getShowValue()[i].iReferenceId);
                    }
                    if (ids.length > 0) {
                        let field = '';
                        if (data && data.cellName == "sProductSkuCode") {
                            field = 'productId.';
                        }
                        //1商品分类 2 商品模板 3 商品品牌 4 商品标签
                        let simpleConditions = [];
                        if (viewmodel.get('actityItemType').getValue() == 1) {
                            field += 'productClass';
                        } else if (viewmodel.get('actityItemType').getValue() == 2) {
                            field += 'productTemplate';
                        } else if (viewmodel.get('actityItemType').getValue() == 3) {
                            field += 'brand';
                        } else if (viewmodel.get('actityItemType').getValue() == 4) {
                            field += 'productTags.tagId';
                        }
                        if (data.context.getFilter() && data.context.getFilter().simpleVOs) {
                            data.context.getFilter().simpleVOs.push({
                                field: field,
                                op: 'in',
                                value1: ids
                            });
                        } else {
                            let condition = {
                                "isExtend": true,
                                simpleVOs: []
                            };
                            condition.simpleVOs.push({
                                field: field,
                                op: 'in',
                                value1: ids
                            });
                            data.context.setFilter(condition);
                        }
                    }
                } else {
                    if (viewmodel.get('pActivityRange').getValue() == 1) {
                        cb.utils.alert('请选择适用商品类型', 'warning');
                        return false;
                    }
                }
                return true;
            })

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                let counts = viewmodel.get('pricePreProduct').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("pricePreProduct").deleteRows(rowIndexes);
            })

            //清除全部商品
            viewmodel.on('batchProDelete1', function (args) {
                let counts = viewmodel.get('pricePreMustBuyPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("pricePreMustBuyPro").deleteRows(rowIndexes);
            })

            //清除全部商品
            viewmodel.on('batchProDelete2', function (args) {
                let counts = viewmodel.get('pricePreExceptionPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("pricePreExceptionPro").deleteRows(rowIndexes);
            })

            viewmodel.on('statictempexport', function (params) {
                const openUrl = params && params.cSvcUrl;
                if (!openUrl) {
                    cb.utils.alert('导出模板的地址为空', 'error');
                    return;
                }
                window.open(openUrl);
            });

            viewmodel.on('batchimport', function (params) {
                const url = `${params.cSvcUrl}?token=${cb.rest.AppContext.token}&billnum=pmc_pricepreferential`;
                const eleInput = document.createElement('input');
                eleInput.type = 'file';
                eleInput.style.display = 'none';
                eleInput.onchange = function (e) {
                    const formData = new FormData();
                    formData['enctype'] = 'multipart/form-data';
                    formData.append('file', e.target.files[0]);

                    var param = {};
                    param.type = 2;
                    param.applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    param.applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    formData.append('data', JSON.stringify(param));

                    cb.utils.alert(`导入中，请稍后`, 'info');

                    const xhr = new XMLHttpRequest();
                    xhr.open('POST', url, true);
                    xhr.send(formData);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState !== 4) return;
                        if (xhr.status === 200) {
                            var ajaxResult = JSON.parse(xhr.responseText);
                            if (ajaxResult.code === 200) {
                                if (ajaxResult.data.code === 200) {
                                    var array = [];
                                    var res = ajaxResult.data.data;
                                    var gridModel = viewmodel.get('pricePreProduct');
                                    for (let i = 0; i < res.data.length; i++) {
                                        var appendData = {};
                                        var data = res.data[i];
                                        appendData.proIdType = data.proIdType;
                                        if (appendData.proIdType == 0) {
                                            appendData.sProductCode = data.cCode;
                                            appendData.sProductName = data.cProductName;
                                        } else {
                                            appendData.sProductCode = data.productCode;
                                            appendData.sProductName = data.productName;
                                            appendData.sProductSkuCode = data.cCode;
                                            appendData.sProductSkuName = data.cProductName;
                                        }
                                        appendData.agentId = data.agentId;
                                        appendData.fMarketPrice = data.fMarketPrice;
                                        appendData.fSalePrice = data.fSalePrice;
                                        appendData.iDeleted = data.iDeleted;
                                        appendData.proId = data.proId;
                                        appendData.sProductPicUrl = data.imageUrl;
                                        array.push(appendData);
                                        // gridModel.appendRow(appendData);
                                    }
                                    let count = gridModel.getRowsCount();
                                    var indexes = [];
                                    for (let i = count - 1; i >= 0; i--) {
                                        indexes.push(i);
                                    }
                                    gridModel.deleteRows(indexes);
                                    gridModel.insertRows(0, array);
                                    var errorMessages = '';
                                    if (res.errorCount) {
                                        for (let i = 0; i < res.allMsgs.length; i++) {
                                            if (res.allMsgs[i].isError) {
                                                errorMessages += res.allMsgs[i].msg;
                                            }
                                        }
                                    }
                                    cb.utils.alert(`共导入${res.totalCount}条, 成功${res.successCount}条, 失败${res.errorCount}条${res.errorCount ? `失败原因是: ${res.errorMsgs + errorMessages}` : ''}`, res.errorCount ? 'error' : 'success');
                                } else {
                                    cb.utils.alert(`${ajaxResult.data.message}，模板内容导入失败`, 'error');
                                }
                            } else {
                                cb.utils.alert(`${ajaxResult.message}，模板内容导入失败`, 'error');
                            }
                        }
                    };
                    document.body.removeChild(eleInput);
                };
                document.body.appendChild(eleInput);
                eleInput.click();
            });

            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.cMonthDays = String(obj.cMonthDays);

                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue() || viewmodel.get("iAreaId").getValue() == 0) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    }
                }

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }
                // else if (this.get('applyOnlineChannel').getValue() == '0') {
                //                 obj.terminalType = 0;
                //             }

                if (this.get('memberLevelAll').getValue() == '0' && this.get('pricePreferentialMemberL').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('memberLevelAll').getValue() != '0') {
                    obj.pricePreferentialMemberL = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('pricePreferentialStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.memberLevelAll == 1) {
                        obj.memberLevelAll = 2;
                    }
                }
                // else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                //                 obj.pricePreferentialStore = [];
                //             }
                if (obj.pActivityRange == '1') {
                    if (obj.actityItemType != 0) {
                        if (!viewmodel.get('pricePreProductClass').getShowValue() || viewmodel.get('pricePreProductClass').getShowValue().length == 0) {
                            switch (obj.actityItemType) {
                                case '1':
                                case 1:
                                    cb.utils.alert('请选择相应的分类信息', 'warning');
                                    return false;
                                case '2':
                                case 2:
                                    cb.utils.alert('请选择相应的模板信息', 'warning');
                                    return false;
                                case '3':
                                case 3:
                                    cb.utils.alert('请选择相应的品牌信息', 'warning');
                                    return false;
                                case '4':
                                case 4:
                                    cb.utils.alert('请选择相应的标签信息', 'warning');
                                    return false;
                            }
                        } else {
                            if (obj.pricePreProductClass) {
                                for (let i = 0; i < obj.pricePreProductClass.length; i++) {
                                    let proClass = obj.pricePreProductClass[i];
                                    proClass['iReferType'] = viewmodel.get("actityItemType").getValue() - 1;
                                }
                            }
                        }
                    } else {
                        if (viewmodel.get('pricePreProduct').getRows() == '') {
                            cb.utils.alert('请选择相应的商品信息', 'warning');
                            return false;
                        } else {
                            for (var i = 0; i < viewmodel.get('pricePreProduct').getRows().length; i++) {
                                if (!viewmodel.get('pricePreProduct').getRows()[i].proId ) {
                                    cb.utils.alert('第' + (i + 1) + '行选择相应的商品信息', 'warning');
                                    return false;
                                }
                            }
                        }
                    }
                }

                if (viewmodel.get('bMusetBuyProduct').getValue() == 1) {
                    if (!viewmodel.get('pricePreMustBuyPro').getRows() || viewmodel.get('pricePreMustBuyPro').getRows().length < 1) {
                        cb.utils.alert('请选择必选商品', 'warning');
                        return false;
                    } else {
                        for (let i = 0; i < viewmodel.get('pricePreMustBuyPro').getRows().length; i++) {
                            if (!viewmodel.get('pricePreMustBuyPro').getRows()[i].iProductId) {
                                cb.utils.alert('请选择第' + (i + 1) + '行必选商品', 'warning');
                                return false;
                            }
                            if (!viewmodel.get('pricePreMustBuyPro').getRows()[i].fSalePrice && viewmodel.get('applyOnlineChannel').getValue() == '1') {
                                cb.utils.alert('请维护第' + (i + 1) + '行必选商品的线上零售价', 'warning');
                                return false;
                            }
                            if (!viewmodel.get('pricePreMustBuyPro').getRows()[i].fMarkPrice && viewmodel.get('applyOffLineChannel').getValue() == '1') {
                                cb.utils.alert('请维护第' + (i + 1) + '行必选商品的市场价', 'warning');
                                return false;
                            }
                        }
                    }
                }

                if (viewmodel.get('bExceptionalProduct').getValue() == 1) {
                    if (!viewmodel.get('pricePreExceptionPro').getRows() || viewmodel.get('pricePreExceptionPro').getRows().length < 1) {
                        cb.utils.alert('请选择例外商品', 'warning');
                        return false;
                    } else {
                        for (let i = 0; i < viewmodel.get('pricePreExceptionPro').getRows().length; i++) {
                            if (!viewmodel.get('pricePreExceptionPro').getRows()[i].iProductId) {
                                cb.utils.alert('请选择第' + (i + 1) + '行例外商品', 'warning');
                                return false;
                            }
                            if (!viewmodel.get('pricePreExceptionPro').getRows()[i].fSalePrice && viewmodel.get('applyOnlineChannel').getValue() == '1') {
                                cb.utils.alert('请维护第' + (i + 1) + '行例外商品的线上零售价', 'warning');
                                return false;
                            }
                            if (!viewmodel.get('pricePreExceptionPro').getRows()[i].fMarkPrice && viewmodel.get('applyOffLineChannel').getValue() == '1') {
                                cb.utils.alert('请维护第' + (i + 1) + '行例外商品的市场价', 'warning');
                                return false;
                            }
                        }
                    }
                }
                if (viewmodel.get('pStartDate').getValue() >= viewmodel.get('pEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                for (var i = 0; i < viewmodel.get('pricePreferentialItem').getRows().length; i++) {

                    let priceItem = viewmodel.get('pricePreferentialItem').getRows()[i];
                    // if (!priceItem.consumerSpending) {
                    // cb.utils.alert('第' + (i + 1) + '行的消费额度不可为0或空', 'warning');
                    // return false;
                    // }
                    // if (!priceItem.consumerPieces) {
                    // cb.utils.alert('第' + (i + 1) + '行的满件额度不可为0或空', 'warning');
                    // return false;
                    // }
                    if ((!priceItem.consumerSpending && !priceItem.consumerPieces)
                        || (priceItem.consumerSpending == 0 && priceItem.consumerPieces == 0)) {
                        cb.utils.alert('第' + (i + 1) + '行的满价额度和满件数量不可同时为0或空', 'warning');
                        return false;
                    }
                    // if (viewmodel.get('pType').getValue() == 0) {
                    //     if (!priceItem.discountNum ||priceItem.discountNum == 0) {
                    //         cb.utils.alert('第' + (i + 1) + '行的打折数目不可为0或空', 'warning');
                    //         return false;
                    //     }
                    // } else
                    if (viewmodel.get('pType').getValue() == 1) {
                        if (!priceItem.fireNum || priceItem.fireNum == 0) {
                            cb.utils.alert('第' + (i + 1) + '行的减价额度不可为0或空', 'warning');
                            return false;
                        }
                    } else if (viewmodel.get('pType').getValue() == 2) {
                        for (var j = i + 1; j < viewmodel.get('pricePreferentialItem').getRows().length; j++) {
                            let priceItems = viewmodel.get('pricePreferentialItem').getRows()[j];
                            if (priceItem.consumerSpending == priceItems.consumerSpending && priceItem.consumerPieces == priceItems.consumerPieces) {
                                cb.utils.alert('阶梯条件不允许相同', 'warning');
                                return false;
                            }
                        }

                        if (!priceItem.giveNum || priceItem.giveNum == 0) {
                            cb.utils.alert('第' + (i + 1) + '行的减免数量不可为0或空', 'warning');
                            return false;
                        }
                        if (priceItem.remitType == 1) {
                            if (!priceItem.cGiftNames) {
                                cb.utils.alert('请选取' + (i + 1) + '行的指定减免商品', 'warning');
                                return false;
                            } else if (viewmodel.get('pActivityRange').getValue == 1 && viewmodel.get('actityItemType').getValue == 0) {
                                let exitIds = priceItem.cGiftIds.split(",");
                                for (let j = 0; j < exitIds.length; j++) {
                                    let flag = false;
                                    for (let h = 0; h < viewmodel.get('pricePreProduct').getRows().length; h++) {
                                        if (viewmodel.get('pricePreProduct').getRows()[h].proId == exitIds[j]) {
                                            flag = true;
                                            break;
                                        }
                                    }
                                    if (!flag) {
                                        cb.utils.alert('第' + (i + 1) + '行的指定减免商品不在活动商品之中，请重新选取', 'warning');
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }
                if (this.get('cMonthDays').getValue() && this.get('cMonthDays').getValue() != '') {
                    obj.cMonthDays = ',' + obj.cMonthDays + ',';
                }

                if (this.get('cWeekDays').getValue() && this.get('cWeekDays').getValue() != '') {
                    obj.cWeekDays = ',' + obj.cWeekDays + ',';
                }
                //每天、每周、每月活动时间控制
                if (this.get('activityMode').getValue() == 1) {
                    if (!this.get('beginTime').getValue() || !this.get('endTime').getValue()) {
                        cb.utils.alert('每天活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('beginTime').getValue() >= this.get('endTime').getValue()) {
                        cb.utils.alert('每天活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                } else if (this.get('activityMode').getValue() == 2) {
                    if (!this.get('cWeekBeginTime').getValue() || !this.get('cWeekEndTime').getValue() || !this.get('cWeekDays').getValue()) {
                        cb.utils.alert('每周活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('cWeekBeginTime').getValue() >= this.get('cWeekEndTime').getValue()) {
                        cb.utils.alert('每周活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                } else if (this.get('activityMode').getValue() == 3) {
                    if (!this.get('cMonthDays').getValue() || !this.get('cMonthBeginTime').getValue() || !this.get('cMonthEndTime').getValue()) {
                        cb.utils.alert('每月活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('cMonthBeginTime').getValue() >= this.get('cMonthEndTime').getValue()) {
                        cb.utils.alert('每月活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                }
                if (obj.pricePreferentialItem) {
                    for (let i = 0; i < obj.pricePreferentialItem.length; i++) {
                        if (!obj.pricePreferentialItem[i].consumerSpending && obj.pricePreferentialItem[i].consumerSpending != 0) {
                            obj.pricePreferentialItem[i].consumerSpending = 0;
                        }
                        if (!obj.pricePreferentialItem[i].consumerPieces && obj.pricePreferentialItem[i].consumerPieces != 0) {
                            obj.pricePreferentialItem[i].consumerPieces = 0;
                        }
                    }
                }

                if (obj.pricePreMustBuyPro) {
                  for (let i = 0; i < obj.pricePreMustBuyPro.length; i++) {
                    if (! obj.pricePreMustBuyPro[i].fSalePrice) {
                      obj.pricePreMustBuyPro[i].fSalePrice = 0;
                    }
                    if (! obj.pricePreMustBuyPro[i].fMarkPrice) {
                      obj.pricePreMustBuyPro[i].fMarkPrice = 0;
                    }
                  }
                }
                if (obj.pricePreExceptionPro) {
                  for (let i = 0; i < obj.pricePreExceptionPro.length; i++) {
                    if (! obj.pricePreExceptionPro[i].fSalePrice) {
                      obj.pricePreExceptionPro[i].fSalePrice = 0;
                    }
                    if (! obj.pricePreExceptionPro[i].fMarkPrice) {
                      obj.pricePreExceptionPro[i].fMarkPrice = 0;
                    }
                  }
                }
                data.data.data = JSON.stringify(obj);

            })
        }
    };
    try {
        module.exports = PM_pmc_wholesale_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_wholesale_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_wholesale_VM.Extend.js